export default __webpack_public_path__ + "static/media/media-profile.675f0e03.jpg";